import _ from "lodash"
import React, { useEffect, useState, memo } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"

//Import selects arrays
import { getIncomeTypes, getStates } from "common/selects"

//Import functions
import { USDFormat } from "common/global/functions"

import IncomeTypeForm from "./_partials/incomeTypeForm"

const IncomeInformationForm = ({
  initialValues,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  submitForm,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  handleIncomeTypeChange,
  ...props
}) => {

  const [selectedIncomeTypeValue, setSelectedIncomeTypeValue] = useState(values.income_typeid);

  const handleCurrencyFormat = e => {
    if(/^\d+(\.\d+)?$/.test(e.target.value))
    setFieldValue(e.target.name, Number(e.target.value).toFixed(2))

    handleBlur(e);
  }

  return (
    <React.Fragment>
      <Form className="form-horizontal" id="income-information-form">
        <Row>
          <Col lg="12">
            <Input
              type="hidden"
              id="key"
              name="key"
              value={values.key || ""}
              invalid={errors.key ? true : false}
            />
            {touched.key && errors.key ? (
              <FormFeedback
                className="mb-3"
                type="invalid"
                style={{ fontSize: "100%" }}
              >
                {errors.key}
              </FormFeedback>
            ) : null}
            
            
            <FormGroup className="mb-3">
                <Label for="income_typeid">Select Income Type</Label>
                <Select
                    id="income_typeid"
                    name="income_typeid"
                    placeholder="Select Income Type"
                    defaultValue={selectedIncomeTypeValue}
                    value={selectedIncomeTypeValue}
                    onBlur={e => {
                      setFieldTouched("income_typeid",true);
                    }}
                    onChange={selectedOption => {
                        let event = {
                          target: {
                              name: "income_typeid",
                              option: selectedOption,
                          },
                        }
                        handleIncomeTypeChange(event)
                    }}
                    isSearchable={true}
                    options={getIncomeTypes()}
                    isLoading={false}
                    loadingMessage={() =>
                        "loading income types"
                    }
                    noOptionsMessage={() => "income_typeid"}
                    invalid={
                        touched.income_typeid &&
                        errors.income_typeid &&
                        errors.income_typeid.value
                        ? true
                        : false
                    }
                />
                { touched.income_typeid && errors.income_typeid && errors.income_typeid.value ? 
                (
                    <FormFeedback
                        type="invalid"
                        style={{display: "block",fontSize: "100%",}}
                    >
                        {errors.income_typeid.value}
                    </FormFeedback>
                ) : null}
            </FormGroup>
          </Col>
        </Row>
                
          {/* Partial Income Description*/}
          <IncomeTypeForm
              initialValues={initialValues}
              values={values}
              errors={errors}
              touched={touched}
              getStates={getStates}
              handleChange={handleChange}
              handleBlur={handleBlur}
              incomeTypeid={values.income_typeid}
              handleCurrencyFormat={handleCurrencyFormat}
          />
          {/* End Partial Income Description*/}
        {values.income_typeid.value && values.income_typeid.value != 1 && (
          <>
        <Row>
            <Col lg="12">
              <div className="mb-3">
                <Label for="salary">Monthly Income</Label>
                <Input
                  type="text"
                  className="form-control"
                  id="salary"
                  name="salary"
                  placeholder="Personal Income (Monthly)"
                  onChange={handleChange}
                  onBlur={handleCurrencyFormat}
                  value={values.salary || ""}
                  invalid={
                    touched.salary &&
                    errors.salary
                      ? true
                      : false
                  }
                />
                {touched.salary &&
                errors.salary ? (
                  <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                    {errors.salary}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
          </Row>
          </>
        )}
          {values.income_typeid.value && (
          <>
          <Row>
            <Col lg="12">
              <div className="mb-3">
                <Label for="household_income">
                  Monthly Household Income
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="household_income"
                  name="household_income"
                  placeholder="Enter Applicant Household Income (Monthly)"
                  onChange={handleChange}
                  onBlur={handleCurrencyFormat}
                  value={values.household_income || ""}
                  invalid={
                    touched.household_income &&
                    errors.household_income
                      ? true
                      : false
                  }
                />
                {touched.household_income && errors.household_income ? (
                  <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                    {errors.household_income}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
          </Row>
          </>
        )}
      </Form>
    </React.Fragment>
  )
};

export default IncomeInformationForm 
